import baseApi from './baseApi';

export type GetPlacesAutoCompleteInput = {
  input: string;
  siteDomain: string;
};

export type GooglePlacesAutoCompleteResponse = {
  suggestions: GooglePlacesAutoCompleteSuggestions[];
};

export type GooglePlacesAutoCompleteSuggestions = {
  placePrediction: {
    placeId: string;
    text: {
      text: string;
    };
  };
};

export type GooglePlaceAddressComponents = {
  longText: string;
  shortText: string;
  types: GooglePlacesAddressTypes[];
  languageCode: string;
};
export type GooglePlacesAddressTypes =
  | 'street_number'
  | 'subpremise'
  | 'route'
  | 'locality'
  | 'sublocality'
  | 'sublocality_level_1'
  | 'administrative_area_level_1'
  | 'administrative_area_level_2'
  | 'country'
  | 'postal_code';

export type GooglePlacesInfoResponse = {
  addressComponents: GooglePlaceAddressComponents[];
  displayName: {
    text: string;
  };
  formattedAddress: string;
};

// Define goole maps api service
export const googleMapsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlacesAutoComplete: builder.query<
      GooglePlacesAutoCompleteResponse,
      GetPlacesAutoCompleteInput
    >({
      query: ({ input, siteDomain }) => {
        const urlSafeInput = encodeURI(input);
        return {
          url: `/api/member-portal/${siteDomain}/googlePlaces/googleMapsPlacesAutocomplete?input=${urlSafeInput}`,
          method: 'GET',
        };
      },
    }),
    getPlacesInfo: builder.query<
      GooglePlacesInfoResponse,
      GetPlacesAutoCompleteInput
    >({
      query: ({ input, siteDomain }) => {
        const urlSafePlaceId = encodeURI(input);
        return {
          url: `/api/member-portal/${siteDomain}/googlePlaces/googleMapsPlacesInfo?placeId=${urlSafePlaceId}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetPlacesAutoCompleteQuery,
  useGetPlacesInfoQuery,
  useLazyGetPlacesInfoQuery,
} = googleMapsApi;
